<template>
  <div class="container">
    <Header :active="3"></Header>
    <Price1></Price1>
    <Price5></Price5>
    <!-- <Price2></Price2>
    <Price4></Price4> -->
    <div class="price-signin">
      <p class="signin-title">新用户注册即送 60 元代金券</p>
      <p class="signin-desc">无门槛使用，免费体验顶级云渲染服务</p>
      <div class="signin-btn">
        <a target="_blank" href="https://v.renderg.com/#/register?flag=register">立即注册</a>
      </div>
    </div>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
import Price1 from '../components/Price/price1'
import Price5 from '../components/Price/price5'
// import Price2 from '../components/Price/price2'
// import Price3 from '../components/Price/price3'
// import Price4 from '../components/Price/price4'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    Price1,
    Price5,
    Position,
    Footer
  },
}
</script>
